export enum WorkOrderReportTypes {
  STANDARD = 'standard',
  SIMPLIFIED = 'simplified',
  ADVANCED = 'advanced',
  SIMPLIFIED_WITH_TASKS = 'simplified_with_tasks',
  CUSTOM = 'custom',
  WO_INVOICE_REPORT = 'wo_invoice_report',
  PROFITABILITY_REPORT = 'profitability_report'
}
